module.exports = ExcelJS;


//////////////////
// WEBPACK FOOTER
// external "ExcelJS"
// module id = Bm/x
// module chunks = 78